import { format } from "date-fns";
import { type UserInvitationResponse } from "../api";
import { Utility } from "./utility";

export interface UserInvitation extends UserInvitationResponse {}

export class UserInvitation extends Utility<UserInvitation> {
  constructor(init?: Partial<UserInvitationResponse>) {
    super();
    Object.assign(this, init);
  }

  get local_created_at(): Date | null {
    if (this.created_at === null || this.created_at === undefined) return null;
    return this.get_local_time(this.created_at);
  }

  get local_created_at_date_string(): string | null {
    if (this.local_created_at === null) return null;
    return format(this.local_created_at, "MMM d, hh:mm aaa");
  }

  get local_expires_at(): Date | null {
    if (this.expires_at === null || this.expires_at === undefined) return null;
    return this.get_local_time(this.expires_at);
  }

  get local_expires_at_date_string(): string | null {
    if (this.local_expires_at === null) return null;
    return format(this.local_expires_at, "MMM d, hh:mm aaa");
  }
}
